import React from 'react';

import ProgressBar from 'react-bootstrap/ProgressBar';
import { Text } from 'v3/components';

function LoadingProgressBar({ text = 'Carregando...' }) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.34)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: '0 40px',
      }}
    >
      <Text weight={700} color="dark" type="body">{text}</Text>
      <ProgressBar animated now={100} style={{ width: '100%', maxWidth: 400 }} />
    </div>
  );
}

export default LoadingProgressBar
